'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoGearA = function IoGearA(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.1 20c0 1.9 1.2 3.4 2.9 4.4-0.3 1-0.8 2-1.2 2.9-2-0.4-3.6 0.3-4.9 1.6s-1.7 2.9-1.2 4.9c-1 0.4-2 0.9-3 1.2-1-1.7-2.8-2.9-4.7-2.9s-3.7 1.2-4.7 2.9c-1-0.3-2.1-0.8-3-1.2 0.4-2 0.1-3.6-1.2-4.9s-2.9-1.6-4.9-1.2c-0.4-0.9-0.9-2-1.2-3 1.7-1 2.9-2.8 2.9-4.7s-1.2-3.4-2.9-4.4c0.3-1 0.7-2 1.3-2.9 1.9 0.4 3.5-0.3 4.8-1.6s1.6-2.9 1.2-4.9c0.9-0.4 2-0.9 3-1.2 1 1.7 2.8 2.9 4.7 2.9s3.7-1.2 4.7-2.9c1 0.3 2.1 0.8 3 1.3-0.4 1.9-0.1 3.5 1.2 4.8s2.9 2 4.8 1.6c0.5 0.9 1 1.9 1.3 2.9-1.7 1-2.9 2.5-2.9 4.4z m-12.1 7.7c4.2 0 7.7-3.5 7.7-7.7s-3.5-7.7-7.7-7.7-7.7 3.5-7.7 7.7 3.5 7.7 7.7 7.7z' })
        )
    );
};

exports.default = IoGearA;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/gear-a.js
// module id = 2270
// module chunks = 0